import React from 'react';
import HeaderFooterHOC from '../HOC/HeaderFooterHOC';
import CadastralMap from "../components/CadastralMap";

const CadastralMapPage = (props) => {

    const latLng = (props.latLng.length > 1) ? props.latLng.split(',') : false;

    return (!!latLng &&
        <CadastralMap
            lat={latLng[0]}
            lng={latLng[1]}
        />
    )

    return '';

}

export default HeaderFooterHOC(CadastralMapPage, 'cadastral-map');
